<div class="relative">
  <div class="hover:scale-110 transition-transform duration-200">
    <app-notification-icon
      class="cursor-pointer"
      (click)="toggleDropdown()"
      [notificationCount]="notifications().length"
      appAgentAction
      agent="notification-dropdown-toggle"
      action="toggle"
    ></app-notification-icon>
  </div>
  <div
    [ngClass]="{
      'opacity-0 pointer-events-none': !isDropdownOpen,
      'opacity-100': isDropdownOpen,
    }"
    id="dropdownHelperRadio"
    class="z-10 bg-white/90 border border-gray-300 rounded-md shadow-lg w-56 max-h-96 overflow-y-auto absolute right-0 transition-opacity duration-200"
  >
    <ul class="p-2 text-sm text-body font-medium" aria-labelledby="dropdownHelperRadioButton">
      @for (notification of notifications(); track $index) {
        <li>
          <div class="flex p-2 w-full rounded items-start hover:bg-gray-50 transition-colors duration-200">
            <div class="ms-2 text-sm">
              <label for="helper-radio-4" class="font-medium text-heading">
                <div class="mb-1">{{ notification?.title }}</div>
                <p
                  id="helper-radio-text-4"
                  class="text-xs font-normal text-body"
                  [ngClass]="{ 'text-red-500': notification.error }"
                >
                  {{ notification?.message }}
                </p>
              </label>
            </div>
            <button
              class="cursor-pointer hover:text-amazone-orange transition-colors duration-200"
              (click)="removeNotification(notification.notificationId)"
              appAgentAction
              [agent]="'notification-dropdown-remove-' + notification.notificationId"
              action="remove"
            >
              <app-close-icon></app-close-icon>
            </button>
          </div>
        </li>
      } @empty {
        <li>
          <div class="flex p-2 w-full rounded items-start hover:bg-gray-50 transition-colors duration-200">
            <div class="ms-2 text-sm">
              <label for="helper-radio-4" class="font-medium text-heading text-gray-700">No notifications</label>
            </div>
          </div>
        </li>
      }
    </ul>
  </div>
</div>
